module.exports = __webpack_public_path__ + "img/light-off.58c1d842.svg";